import { connect } from 'react-redux';
import { getFormErrorStyles } from 'common/entities/form/styleConfiguration/selectors';
import { getErrorMessages } from 'common/entities/form/selectors';
import { withFormId } from '../components/FormIdContext';

const mapStateToProps = (state, props) => {
    const { formId } = props;

    const errorMessagesTextStyles = getFormErrorStyles(state, formId);
    const formErrorMessages = getErrorMessages(state, formId);

    return {
        font: errorMessagesTextStyles.font,
        fontSize: errorMessagesTextStyles.fontSize,
        color: errorMessagesTextStyles.color,
        formErrorMessages,
    };
};

export default (WrappedComponent) => withFormId(connect(mapStateToProps, {})(WrappedComponent));
